export const EVENT_CURRENCY_RATES_CHANGE = 'currencyRates.change'
